import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from 'elc-service';
import { INFO_POPUP_TRIGGER } from '../../constants/AutoReplenish';
import { classes } from '../../utils/Classes';
import { Button } from 'elc-buttons';
import { InfoIcon } from 'elc-icons';

export interface ProductAutoReplenishInfoModalTriggerOptions {
    translations?: ITranslationsCollection;
    triggerType?: INFO_POPUP_TRIGGER;
    onClick(): void;
}

@translate(['learnMoreLabel', 'openLabel', 'closeLabel', 'autoReplenishMoreInformation'])
@observer
export class ProductAutoReplenishInfoModalTrigger extends React.Component<
    ProductAutoReplenishInfoModalTriggerOptions
> {
    public render() {
        const { translations, triggerType } = this.props;

        const openModalClassNames = classes('auto-replenish-open-modal');
        const autoReplenishModalTriggerIconClass = classes('auto-replenish-modal-trigger-icon');
        const autoReplenishModalTriggerTextClass = classes('auto-replenish-modal-trigger-text');

        const {
            openLabel,
            learnMoreLabel,
            autoReplenishMoreInformation
        } = translations as ITranslationsCollection;

        const trigger =
            triggerType === INFO_POPUP_TRIGGER.TEXT ? (
                <span className={autoReplenishModalTriggerTextClass}>{learnMoreLabel}</span>
            ) : (
                <InfoIcon className={autoReplenishModalTriggerIconClass} />
            );

        return (
            <Button
                onClick={this.props.onClick}
                className={openModalClassNames}
                aria-label={`${openLabel} ${autoReplenishMoreInformation}`}
                title={`${openLabel} ${autoReplenishMoreInformation}`}
            >
                {trigger}
            </Button>
        );
    }
}
